import { TrendingUp, ArrowUpRight } from "lucide-react";
import { Container, Section, Eyebrow, Reveal } from "@/components/kit";

const cases = [
  {
    tag: "Series B · DevTools",
    title: "From flat pipeline to 38 qualified meetings a month",
    metric: "+312%",
    metricLabel: "SQL pipeline in 90 days",
    img: "https://images.unsplash.com/photo-1758073519996-6d3c63b4922c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGdsb3dpbmclMjBkYXRhJTIwdGVjaHxlbnwwfHx8fDE3ODU1NTg1OTF8MA&ixlib=rb-4.1.0&q=85",
    body: "A developer-tools startup replaced a stalled SDR team with Appointment Lab and tripled qualified pipeline in a single quarter.",
  },
  {
    tag: "Growth-stage · Cybersecurity",
    title: "$1.9M in influenced pipeline, zero wasted spend",
    metric: "$1.9M",
    metricLabel: "Influenced pipeline",
    img: "https://images.pexels.com/photos/8463151/pexels-photo-8463151.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    body: "By scoring accounts against a strict ICP model, we booked only enterprise-fit meetings — and the client paid for nothing else.",
  },
  {
    tag: "Seed · Fintech SaaS",
    title: "94% ICP-match rate across every booked call",
    metric: "94%",
    metricLabel: "ICP-match accuracy",
    img: "https://images.unsplash.com/photo-1676989880361-091e12efc056?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMHRlY2glMjBwb3J0cmFpdHxlbnwwfHx8fDE3ODIxNTY5MzR8MA&ixlib=rb-4.1.0&q=85",
    body: "Precision targeting meant the founder's calendar filled with exactly the buyers they wanted — nothing off-profile slipped through.",
  },
];

export const CaseStudies = () => (
  <Section data-testid="case-studies" className="bg-navy-800/30 border-y border-white/10">
    <Container>
      <div className="max-w-3xl">
        <Eyebrow>Proof, Not Promises</Eyebrow>
        <h2 className="mt-6 font-display text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-white">
          Results from the lab
        </h2>
        <p className="mt-6 text-white/60 text-base md:text-lg leading-relaxed">
          Representative outcomes from B2B tech and SaaS teams running Appointment Lab.
        </p>
      </div>

      <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {cases.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.1}>
            <article className="group h-full overflow-hidden rounded-2xl border border-white/10 bg-navy-900 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-2 hover:border-gold/50 hover:shadow-[0_0_40px_rgba(255,215,0,0.12)]">
              <div className="relative h-44 overflow-hidden">
                <img
                  src={c.img}
                  alt={c.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/40 to-transparent" />
                <span className="absolute left-4 top-4 rounded-full border border-white/15 bg-navy-900/70 backdrop-blur px-3 py-1 font-mono-jb text-[10px] uppercase tracking-widest text-white/70">
                  {c.tag}
                </span>
              </div>
              <div className="p-7">
                <div className="flex items-end gap-3">
                  <span className="font-mono-jb text-3xl font-semibold text-gold text-glow-gold">
                    {c.metric}
                  </span>
                  <span className="pb-1 text-xs text-white/50">{c.metricLabel}</span>
                </div>
                <h3 className="mt-4 font-display text-lg font-semibold leading-snug text-white">
                  {c.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-white/55">{c.body}</p>
                <div className="mt-5 inline-flex items-center gap-2 font-mono-jb text-xs text-gold/80">
                  <TrendingUp className="h-4 w-4" />
                  Performance-verified
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </Container>
  </Section>
);
